import { render, staticRenderFns } from "./RecipientAddressField.vue?vue&type=template&id=5f10a873&scoped=true"
import script from "./RecipientAddressField.vue?vue&type=script&lang=js"
export * from "./RecipientAddressField.vue?vue&type=script&lang=js"
import style0 from "./RecipientAddressField.vue?vue&type=style&index=0&id=5f10a873&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f10a873",
  null
  
)

export default component.exports